import { useCallback, useEffect, useRef, useState } from 'react';
import { Col, Row, Modal, Button, Form, notification, Input, Select, Typography, Divider, FormInstance } from 'antd';
import { mask, unMask } from '../../../../../utils/MascaraDeCampos';
import { Loading } from '../../../../../components/Loading';
import { SairDoSistema } from '../../../../../services/LStorage/SairSistema';
import { EmitirErro } from '../../../../../services/EmitirErro';
import { useNavigate } from 'react-router-dom';
import { api } from '../../../../../services/apiAxios';
import { getToken } from '../../../../../services/LStorage/token';
import { urlEmpresasCargo, urlEmpresasColaborador } from '../../../../../services/urls';
import { colFull, colInputs } from './GridStyle';
import { removeAcento } from '../../../../../utils/RemoveAcentos';
import { UserAddOutlined } from '@ant-design/icons';
import { validacaoPermissao } from '../../../../../services/VerificaSePodeAcessar';

const { Text, Title, Link } = Typography;
interface interfaceCargo {
    cargo: string,
    id: number
}

interface IntefEmpresas {
    "id": string,
    "createdAt": string,
    "updatedAt": string,
    "ativo": boolean,
    "nome": string,
    "cnpj": string,
    "telefone": string,
    "endereco": string | null,
    "deletedAt": string | null
}
type interfOpcaoScreen = 'listar' | 'addUpdate';
interface PropsModal {
    id: string | null | undefined;
    alterOpcaoScreen: (opcao: interfOpcaoScreen, id?: string) => void;
    idEmpresa: string | null | undefined;
}

export const ColaboradoresAddOrUpdate = ({ id, alterOpcaoScreen, idEmpresa }: PropsModal) => {

    const navigate = useNavigate();

    const refFormModalAddCargo = useRef<FormInstance>(null);
    const [modalAddCargoVisible, setModalAddCargoVisible] = useState(false);
    const [loadingFormModalCargo, setLoadingFormModalCargo] = useState(false);

    const refForm = useRef<any>(null);
    const refDadosCargoState = useRef<Array<interfaceCargo>>([]);

    const [estaEditando, setEstaEditando] = useState(false);
    const [dadosDoCargoList, setDadosDoCargoList] = useState<Array<interfaceCargo>>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => () => {

        let dadosLocalStorage: string | null = localStorage.getItem('@SisPortaria:colaboradorEditForEmpresa');
        let localUserData: any = null;
        if (typeof dadosLocalStorage == 'string') {
            localUserData = JSON.parse(dadosLocalStorage);
        }

        if (localUserData) {
            localStorage.removeItem('@SisPortaria:colaboradorEditForEmpresa');
        }

    }, []);

    const buscarDadosCargosList = useCallback((setCampo?: any, nome?: any, selectIdAndSet?: any, id?: any) => {

        if (setCampo) {
            refForm.current?.setFieldsValue({ cargoId: nome })
        }

        const buscaDadosCargo = async () => {
            try {
                let result = await api.get(urlEmpresasCargo,
                    { headers: { 'Authorization': 'Bearer ' + getToken() } });

                refDadosCargoState.current = result.data;
                setDadosDoCargoList(result.data)

                if (selectIdAndSet) {
                    let nome = null;
                    await result.data.forEach((val: interfaceCargo) => {
                        if (val.id == id) {
                            nome = val.cargo
                        }
                    });
                    refForm.current?.setFieldsValue(
                        { cargoId: nome }
                    )
                }

            } catch (error) {
                console.error(error);
            }
        }

        buscaDadosCargo();

    }, []);

    const selectCargoPorName = useCallback((nome: any): number | null => {
        let idCargo = null;
        refDadosCargoState.current.forEach(val => {
            if (val.cargo == nome) {
                idCargo = val.id
            }
        });
        return idCargo;

    }, []);

    //setando dados das cidades no selected
    const buscaDadosUsuario = useCallback(() => {

        const buscaCiaddes = async () => {
            try {

                //pega dados do localStorage se existir
                let dadosLocalStorage: string | null = localStorage.getItem('@SisPortaria:colaboradorEditForEmpresa');
                let localUserData: any = null;
                if (typeof dadosLocalStorage == 'string') {
                    localUserData = JSON.parse(dadosLocalStorage);
                }

                if (localUserData) {
                    setLoading(true)

                    setTimeout(() => {
                        refForm.current?.setFieldsValue(
                            {
                                nome: localUserData.nome ? localUserData.nome : undefined,
                                tipo: localUserData.tipo ? localUserData.tipo : undefined,
                                empresaId: localUserData.empresaId ? localUserData.empresaId : undefined,
                            }
                        );

                        if (localUserData.cargoId) {
                            buscarDadosCargosList(true, localUserData.cargoId);
                        } else {
                            buscarDadosCargosList();
                        }

                        if (localUserData.telefone) {
                            const originalValue = unMask(localUserData.telefone);
                            const maskedValue = mask(originalValue, [
                                "(99) 9999-9999",
                                "(99) 9 9999-9999"
                            ]);
                            refForm.current?.setFieldsValue({
                                telefone: maskedValue
                            })
                        }

                        if (localUserData.cpf) {
                            const originalValue = unMask(localUserData.cpf);
                            const maskedValue = mask(originalValue, [
                                "999.999.999-9",
                                "999.999.999-99"
                            ]);
                            refForm.current?.setFieldsValue({
                                cpf: maskedValue
                            })
                        }
                        setLoading(false)
                    }, 500);

                }


            } catch (error) {
                let msgErro: any = (error as Error);
                setLoading(false)

                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    SairDoSistema();
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitirErro(error, true, 'addoredituser_dkwdfaiweyi')
                }


            }
        }

        buscaCiaddes();

    }, []);

    const configuracoesIniciaisDeCriar = useCallback((idEmpresa: any) => {
        setTimeout(() => {
            refForm.current?.setFieldsValue(
                {
                    empresaId: idEmpresa,
                }
            );
        }, 500);

        setEstaEditando(false)

        buscarDadosCargosList();

    }, []);

    useEffect(() => {

        if (typeof id === 'string') {
            if (id === 'criar') {

                //adicionar
                configuracoesIniciaisDeCriar(idEmpresa)
            } else {
                setEstaEditando(true)
                buscaDadosUsuario();

            }
        } else {

            //adicionar
            configuracoesIniciaisDeCriar(idEmpresa)
        }

    }, [idEmpresa, id]);

    const onChangeInputCPF = useCallback((e: any) => {
        const originalValue = unMask(e.target.value);
        const maskedValue = mask(originalValue, [
            "999.999.999-9",
            "999.999.999-99"
        ]);

        refForm.current.setFieldsValue(
            { cpf: maskedValue }
        );
        if (maskedValue.length >= 10) {
            refForm.current.validateFields(["cpf"])
        }

    }, []);

    const onChangeInputTelefone = useCallback((e: any) => {
        const originalValue = unMask(e.target.value);
        const maskedValue = mask(originalValue, [
            "(99) 9999-9999",
            "(99) 9 9999-9999"
        ]);

        refForm.current.setFieldsValue(
            { telefone: maskedValue }
        );

        if (maskedValue.length >= 14) {
            refForm.current.validateFields(["telefone"])
        }

    }, []);

    const submitBotaoSalvar = useCallback(() => {

        const salvarDadosCriar = async (obj: any) => {
            try {
                setLoading(true);
                await api.post(urlEmpresasColaborador, obj,
                    {
                        headers: {
                            'Authorization': 'Bearer ' + getToken()
                        }
                    });

                notification.success({
                    message: 'Sucesso',
                    description:
                        'Dados criados com sucesso!',
                });

                setLoading(false);

                alterOpcaoScreen('listar')

            } catch (error) {
                setLoading(false);
                let msgErro: any = (error as Error);

                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    SairDoSistema();
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitirErro(error, true, 'addoredituser_dkwdfaiweyi')
                }

            }
        }

        refForm.current?.validateFields()
            .then((values: any) => {

                values.telefone = unMask(values.telefone);
                values.cpf = unMask(values.cpf);
                salvarDadosCriar(values);

            })
            .catch((errorInfo: any) => {
                notification.error({
                    message: 'Erro',
                    description:
                        'Preencha os campos obrigatorios!',
                });
            });

    }, []);

    const submitBotaoEditar = useCallback((id: any) => {

        const salvarDadosEditar = async (obj: any) => {
            try {
                setLoading(true);

                await api.put(urlEmpresasColaborador + '/' + id, obj,
                    {
                        headers: {
                            'Authorization': 'Bearer ' + getToken()
                        }
                    });

                notification.success({
                    message: 'Sucesso',
                    description:
                        'Dados editados com sucesso!',
                });

                // setDataListCidades(resultCidade.data);

                setLoading(false);

                alterOpcaoScreen('listar')

            } catch (error) {
                setLoading(false);
                let msgErro: any = (error as Error);

                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    SairDoSistema();
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitirErro(error, true, 'addoredituser_dkwdfaiweyi')
                }


            }
        }

        refForm.current?.validateFields()
            .then((values: any) => {

                values.telefone = unMask(values.telefone);
                values.cpf = unMask(values.cpf);
                salvarDadosEditar(values);

            })
            .catch((errorInfo: any) => {
                notification.error({
                    message: 'Erro',
                    description:
                        'Preencha os campos obrigatorios!',
                });
            });


    }, []);

    const clickSubmitModalAddCargo = useCallback((): void => {
        refFormModalAddCargo.current?.validateFields()
            .then((values: any) => {
                setLoadingFormModalCargo(true);

                const salvarDadosModal = async () => {
                    try {
                        let resultReq = await api.post(urlEmpresasCargo, values,
                            {
                                headers: { 'Authorization': 'Bearer ' + getToken() }
                            });
                        notification.success({
                            message: 'Sucesso',
                            description:
                                'Seus dados foram criados com sucesso!',
                        });

                        setLoadingFormModalCargo(false);
                        buscarDadosCargosList(true, resultReq.data.nome);
                        clickCancelModalAddCargo();
                    } catch (error) {
                        setLoadingFormModalCargo(false);
                        notification.error({
                            message: 'Erro',
                            description:
                                'Não foi possivel salvar, entre em contato com suporte!',
                        });
                    }
                }
                salvarDadosModal();

            })
            .catch((errorInfo: any) => {
                notification.error({
                    message: 'Erro',
                    description:
                        'Preencha os campos obrigatorios!',
                });
            });
    }, []);

    const clickCancelModalAddCargo = useCallback((): void => {
        setModalAddCargoVisible(false);
        refFormModalAddCargo.current?.resetFields();
    }, []);
    const onClickAddCargo = useCallback((): void => {
        setModalAddCargoVisible(true);
    }, []);

    return (
        <>
            <Loading
                loading={loading}
            >
                <Row>
                    <Col {...colFull}>
                        <Title level={4}>
                            <UserAddOutlined style={{ fontSize: 25, marginRight: 10 }} />
                            {`${estaEditando ? 'Editar' : 'Adicionar'} Colaborador`}
                        </Title>
                        <div
                            style={{
                                display: 'flex'
                            }}
                        >
                            <Link
                                onClick={() => [
                                    alterOpcaoScreen('listar')
                                ]}
                                style={{
                                    marginRight: 5
                                }}
                            >
                                <Text
                                    type='secondary' underline
                                >Listagem</Text>
                            </Link>

                            <Text
                                style={{
                                    marginRight: 5
                                }} type='secondary'
                            >/</Text>

                            <Text style={{
                                marginRight: 5
                            }}>
                                {
                                    `${estaEditando ? 'Editar' : 'Adicionar'}`
                                }
                            </Text>
                        </div>
                        <Divider />
                    </Col>
                </Row>
                <Form
                    ref={refForm}
                    name="adicionarUsuario"
                    layout="vertical"
                    // onFieldsChange={onFieldsChange}
                    initialValues={{
                        remember: true,
                    }}
                    // onFinish={onFinish}
                    // onFinishFailed={() => { }}
                    autoComplete="off"
                >
                    <Row>
                        <Col {...colInputs}>
                            <Form.Item
                                style={{
                                    margin: 5
                                }}
                                name="nome"
                                label="Nome"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor digite o nome!',
                                    },
                                ]}
                            >
                                <Input
                                    autoComplete="off"
                                    placeholder="Nome"
                                    className='primeiraLetraMaiuscula'
                                    onChange={() => {

                                        const text = refForm.current?.getFieldValue('nome')
                                        const first = text.charAt(0).toUpperCase()
                                        const rest = text.substring(1);

                                        refForm.current?.setFieldsValue(
                                            { 'nome': first + rest }
                                        )

                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col {...colInputs}>
                            <Form.Item
                                rules={[
                                    {
                                        required: true,
                                        message: "Preencha o cpf!",
                                        max: 14
                                    },
                                    () => ({
                                        validator(rule, value) {
                                            return new Promise((resolve: (value?: any) => void, reject) => {
                                                //CUIDADO AO EDITAR PARA PODER ACEITAR MESMO EMAIL
                                                if (value != '' && value != null) {
                                                    value = unMask(value);

                                                    if (value.length >= 10) {
                                                        // buscarCelularSeJaExiste(value).then(valorPromessa => {
                                                        //     if (valorPromessa) {
                                                        //         reject("Celular já existe!");
                                                        //     } else {
                                                        //         resolve();
                                                        //     }
                                                        // }).catch(error => {
                                                        //     resolve();
                                                        // })
                                                        resolve();
                                                    } else {
                                                        reject("CPF inválido");
                                                    }
                                                } else {
                                                    reject('');
                                                }
                                            });
                                        },
                                    }),
                                ]}
                                name="cpf"
                                label="CPF"
                                style={{ margin: 5 }}
                            >
                                <Input
                                    // type="tel"
                                    autoComplete="off"
                                    onChange={(e) => onChangeInputCPF(e)}
                                    placeholder="999.999.999-9"
                                />
                            </Form.Item>
                        </Col>
                        <Col {...colInputs}>
                            <Form.Item
                                rules={[
                                    {
                                        required: true,
                                        message: "Preencha o telefone!",
                                        max: 16
                                    },
                                    () => ({
                                        validator(rule, value) {
                                            return new Promise((resolve: (value?: any) => void, reject) => {
                                                //CUIDADO AO EDITAR PARA PODER ACEITAR MESMO EMAIL
                                                if (value != '' && value != null) {
                                                    value = unMask(value);
                                                    if (value.length >= 10) {
                                                        // buscarCelularSeJaExiste(value).then(valorPromessa => {
                                                        //     if (valorPromessa) {
                                                        //         reject("Celular já existe!");
                                                        //     } else {
                                                        //         resolve();
                                                        //     }
                                                        // }).catch(error => {
                                                        //     resolve();
                                                        // })
                                                        resolve();
                                                    } else {
                                                        reject("Telefone inválido");
                                                    }
                                                } else {
                                                    reject('');
                                                }
                                            });
                                        },
                                    }),
                                ]}
                                name="telefone"
                                label="Telefone"
                                style={{ margin: 5 }}
                            >
                                <Input
                                    type="tel"
                                    autoComplete="off"
                                    onChange={(e) => onChangeInputTelefone(e)}
                                    placeholder="(44) 9 9999-9999"
                                />
                            </Form.Item>
                        </Col>
                        <Col {...colInputs}>
                            <Form.Item
                                style={{
                                    margin: 5
                                }}
                                name="cargoId"
                                label="Cargo"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor selecione o cargo!',
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    placeholder="Selecione..."
                                    filterOption={(input: any, option: any) => {
                                        let textDigit = removeAcento(input)
                                        let listCidade = removeAcento(option?.children);
                                        return listCidade.indexOf(textDigit) >= 0
                                    }}
                                    dropdownRender={menu => (
                                        <div>
                                            {
                                                validacaoPermissao(['admin']) &&
                                                <>
                                                    <div style={{
                                                        display: 'flex',
                                                        flexWrap: 'nowrap',
                                                        padding: 8
                                                    }}>
                                                        <Button block onClick={onClickAddCargo} type="dashed">Adicionar Cargo</Button>
                                                    </div>
                                                    <Divider style={{ margin: '4px 0' }} />
                                                </>
                                            }
                                            {menu}
                                        </div>
                                    )}
                                >
                                    {
                                        dadosDoCargoList.map((cargo) => {
                                            return (
                                                <Select.Option
                                                    value={cargo.id}
                                                    key={cargo.id}
                                                >
                                                    {cargo.cargo}
                                                </Select.Option>
                                            )
                                        })
                                    }
                                </Select>

                            </Form.Item>
                        </Col>
                        <Col hidden {...colInputs}>
                            <Form.Item
                                name="empresaId"
                                label="Empresa"
                                style={{ margin: 5 }}
                                hidden
                            >
                                <Input disabled hidden />
                            </Form.Item>
                        </Col>
                        <Col {...colFull}>
                            <div className="botaoSalvarStep" style={{
                                flexDirection: 'row',
                                display: 'flex',
                                justifyContent: 'flex-end',
                                // background: 'red'
                            }}>
                                <Button
                                    // type="primary"
                                    style={{
                                        marginTop: 20,
                                        marginRight: 5
                                    }}
                                    onClick={() => {
                                        alterOpcaoScreen('listar')
                                    }}
                                >
                                    {"Cancelar"}
                                </Button>

                                <Button
                                    key="submit"
                                    type="primary"
                                    style={{
                                        marginTop: 20,
                                        marginRight: 5
                                    }}
                                    onClick={() => {
                                        estaEditando ?
                                            submitBotaoEditar(id ? id : 'criar')
                                            :
                                            submitBotaoSalvar()
                                    }}
                                >
                                    {"Salvar"}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </Loading>
            <Modal
                title="Adicionar cargo"
                className="modalAddCargo"
                visible={modalAddCargoVisible}
                onOk={clickSubmitModalAddCargo}
                onCancel={clickCancelModalAddCargo}
                footer={[
                    <Button key="back" onClick={clickCancelModalAddCargo}>
                        Cancelar
                    </Button>,
                    <Button key="submit" type="primary" onClick={clickSubmitModalAddCargo}>
                        Salvar
                    </Button>,
                ]}
            >
                <Loading loading={loadingFormModalCargo}>
                    <Form
                        ref={refFormModalAddCargo}
                        name="formModalAddCargo"
                        layout="vertical"
                        initialValues={{
                            remember: true,
                        }}
                    >
                        <Row>
                            <Col span={24}>
                                <Form.Item
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor digite o nome do cargo!',
                                        }
                                    ]}
                                    name="nome"
                                    label="Nome"
                                >
                                    <Input
                                        placeholder="Nome do cargo"
                                        onChange={() => {

                                            const text = refFormModalAddCargo.current?.getFieldValue('nome')
                                            const first = text.charAt(0).toUpperCase()
                                            const rest = text.substring(1);

                                            refFormModalAddCargo.current?.setFieldsValue(
                                                { 'nome': first + rest }
                                            )

                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Loading>
            </Modal>
        </>
    );
}
